module.exports = __webpack_public_path__ + "img/hotdog.80eb79dd.svg";